import React, { useState, useEffect } from 'react';
import { Redux, Slices } from 'spwa-ui-library';
import { Link, useLocation, useNavigate } from '@reach/router';
import ProductCard from '../ProductCard';
import ClassNames from 'classnames';
import { useIntl } from 'react-intl';
import Loader from '../Loader';
import { generateProductRoute } from 'spwa-ui-library/esm/utils/path';
import ProductTile from '../../components/ProductTile';
import ProductCustomizationDialog from '../ProductTileList/ProductCustomizationDialog';
import BundleGroupDialog from '../ProductTileList/BundleGroupDialog';
import { decimalChecker } from 'spwa-ui-library/esm/utils/helper';
import { addToCartGA, trackingAddedToCartGA } from 'spwa-ui-library/esm/utils/helperGA';
import css from './index.module.scss';
import { getAPIConfig } from 'spwa-ui-library/esm/api/config';
import Service from 'spwa-ui-library/esm/api/service';
import { getClusterId } from 'spwa-ui-library/esm/redux/store/configSlice';
const { useSelector, useDispatch } = Redux;
const { sendCart, sendLocalCart, cartItems, selectCartStatus, updateWithIndex } = Slices.cartSlice;
const { selectDefaultAddress } = Slices.addressSlice;
const { selectDesktop } = Slices.appSlice;
const { selectFirstMenu } = Slices.menuSlice;
const { selectCurrentCountry } = Slices.profileSlice;
const { addProductToCustomize, updateProductPayload } = Slices.tempCartSlice;
const {
  productItemsList,
  selectProductEntities,
  selectProductFetchedStatus,
  setDetailsFetched,
  setProductItems,
  getProductInfo,
  fetchProductsByCategoryId,
  addNewProduct,
} = Slices.productSlice;
const { selectProductBaseURL, selectCountryValidations } = Slices.configSlice;

export default function ProductList({ widgetData }) {
  const { products } = widgetData;
  const dispatch = useDispatch();
  const location = useLocation();
  const locationSearch = new URLSearchParams(location.search);
  const intl = useIntl();
  const auth = useSelector((state) => state.auth);
  const productButtonTitle = intl.formatMessage({ id: 'productcard_view' });
  const isDesktop = useSelector(selectDesktop);
  const temp = useSelector((state) => state.tempCart);
  const cart = useSelector(cartItems);
  const allCategory = useSelector((state) => state.category);
  const fetchState = useSelector((state) => state.cart);
  const offer = useSelector((state) => state.offer);
  const address = useSelector(selectDefaultAddress);
  const profile = useSelector((state) => state.profile);
  const menu = useSelector(selectFirstMenu);
  const cartState = useSelector(selectCartStatus);
  const productsMap = useSelector(selectProductEntities);
  const couponCode = offer.apply ? offer.apply.couponCode : '';
  const [pageLoader, setPageLoader] = useState(false);
  const productUrl = useSelector(selectProductBaseURL);
  const productsList = useSelector((state) => state.product);
  const categoryList = useSelector((state) => state.category);
  const productItems = useSelector(productItemsList);
  const isDetailFetched = useSelector(selectProductFetchedStatus);
  const country = useSelector(selectCurrentCountry);
  const countryValidations = useSelector((state) => selectCountryValidations(state, country));

  const currency = countryValidations?.currency;

  const [showBundleGroupDialog, setShowBundleGroupDialog] = useState(0);
  const [showCustomizeProductDialog, setShowCustomizeProductDialog] = useState(0);

  const clusterId = useSelector(getClusterId);

  const arr1 = [...products];
  const sortedProducts = arr1.sort((a, b) => parseInt(a.sequence) - parseInt(b.sequence));

  const navigate = useNavigate();

  let productCard = true;
  let productTile = false;
  if (widgetData?.widgetType === 'WHATS_NEW') {
    productCard = false;
    productTile = true;
  }

  // FETCH PRODUCTS DETAILS
  const fetchProducts = async (data) => {
    await Service.fetch(getAPIConfig('getProductsDetailsIncludingSteps'), {
      postData: { ...data },
    }).then((res) => {
      if (res && res?.data?.data && res?.data?.data) {
        dispatch(setProductItems(res?.data?.data));
      }
    });
  };
  // USEEFFECT CALL TO FETCH THE PRODUCTS DETAILS ON INTIAL RENDER

  const handleBannerClick = (id, categoryId, route) => {
    dispatch(
      fetchProductsByCategoryId({
        id: categoryId,
        cluster: clusterId,
        Language: intl.locale.charAt(0).toUpperCase() + intl.locale.slice(1),
      })
    ).then((resp) => {
      dispatch(
        getProductInfo({
          id: id,
          cluster: clusterId,
          service: address?.addressSubType || 'DELIVERY',
          categoryId: categoryId,
          Language: intl.locale.charAt(0).toUpperCase() + intl.locale.slice(1),
        })
      ).then((productData) => {
        dispatch(addNewProduct(productData?.payload));
        dispatch(
          addProductToCustomize({
            productType: productData?.payload?.bundleTypeId,
            updatedOn: new Date().getTime(),
            mainProductId: productData?.payload?.id,
            data: {
              ...productData?.payload,
              id: productData?.payload?.id,
              category: productData?.payload?.categories[0],
              noIncrement: true,
            },
          })
        );

        setTimeout(() => {
          navigate(route, {
            state: {
              retUrl: `/${intl.locale}/home`,
              oldLocation: JSON.parse(JSON.stringify(location)),
              description: intl.formatMessage({ id: 'customize_your_meals' }),
            },
          });
        }, 100);
      });
    });
  };

  useEffect(() => {
    if (
      productItems &&
      productItems.length === 0 &&
      widgetData.title === 'TOP DEALS' &&
      widgetData.widgetType === 'BEST_SELLERS' &&
      sortedProducts.length > 0 &&
      !isDetailFetched
    ) {
      dispatch(setDetailsFetched(true));
      sortedProducts &&
        sortedProducts.length &&
        sortedProducts.forEach((item) => {
          const {
            action: { category_id, id },
          } = item;
          if (id !== '' && category_id !== '') {
            const data = {
              id,
              categoryId: category_id,
              cluster: clusterId,
              service: 'DELIVERY',
              apiAction: 'getProductsDetailsIncludingSteps',
            };
            fetchProducts(data);
          }
        });
    }
    return () => {
      dispatch(setDetailsFetched(false));
    };
  }, [
    clusterId,
    dispatch,
    fetchProducts,
    isDetailFetched,
    productItems,
    sortedProducts,
    widgetData.title,
    widgetData.widgetType,
  ]);

  // ADD TO CART METHOD
  const addtoCart = (prod, mapKey) => {
    setPageLoader(true);
    const category = categoryList.entities[productsMap[prod?.id]?.['categories']?.[0]];
    // check for variants in tempCart/customization
    const productVariationObject = temp.customize.items?.findLast((item) => item.id == prod.id);
    let specialPrice = productVariationObject?.price || prod?.specialPrice || prod?.originalPrice;

    if (productsMap[prod.id]?.items) {
      let variationArray = [-1, -1, -1];
      Object.values(productVariationObject?.variants || {}).forEach((variant, index) => {
        variationArray[index] = variant;
      });

      let variationItem = productsMap[prod.id]?.items?.find((item, index) => {
        let itemInfo;
        if (!item?.id) {
          itemInfo = productsMap[item];
        } else {
          itemInfo = item;
        }
        let isVariantSame = true;
        variationArray.forEach((variant, index) => {
          if (itemInfo[`sel${index + 1}Value`] != variant) {
            isVariantSame = false;
          }
        });
        return isVariantSame;
      });

      if (variationItem && !variationItem?.id) {
        variationItem = productsMap[variationItem];
      }

      specialPrice = variationItem?.specialPrice || variationItem?.originalPrice || specialPrice;
    }

    let cartDefaultItemIndex = cart?.data?.items?.findIndex(
      (c) => c?.id == prod?.id && c.price == specialPrice && c.isDefault
    );

    if (cartDefaultItemIndex > -1) {
      let itemPayload = cart?.data?.items?.[cartDefaultItemIndex];
      let itemPerUnitPrice = (itemPayload?.price || 0) / (itemPayload?.qty || 1);
      dispatch(
        updateWithIndex({
          index: cartDefaultItemIndex,
          productPayload: {
            ...itemPayload,
            price: itemPerUnitPrice * ((itemPayload?.qty || 1) + 1),
            qty: (itemPayload?.qty || 1) + 1,
          },
        })
      );
    } else {
      if (productVariationObject?.id) {
        dispatch(
          updateProductPayload({
            data: productVariationObject,
          })
        );
      }

      dispatch(
        sendLocalCart({
          productType: prod.bundleTypeId,
          updatedOn: new Date().getTime(),
          mainProductId: prod.id,
          // data: { ...prod, items: productsMap[prod.id].items, category: category.id },
          data: {
            ...prod,
            items: null,
            specialPrice: specialPrice,
            category: category?.id == 999 ? prod?.categories?.[0] : category?.id,
          },
        })
      );
    }

    setTimeout(() => {
      setPageLoader(false);
    }, 0);
    addToCartGA(prod, currency, prod?.name || '', 'ProductListPage');
    trackingAddedToCartGA(prod, currency, category?.name || '', address);
    return cartState;
  };

  const handleBundleGroupAction = (optionId) => {
    setPageLoader(true);
    setShowBundleGroupDialog(0);
    const category = categoryList.entities[productsMap[showBundleGroupDialog]?.['categories']?.[0]];
    let productRoute = generateProductRoute({
      product: productsMap[showBundleGroupDialog],
      category,
      locale: intl.locale.toLowerCase(),
    });
    productRoute = `${productRoute}/bundle?bundleGroup=1&option=${optionId}`;

    if (locationSearch.has('cartId')) {
      productRoute = `${productRoute}&cartId=${locationSearch.get('cartId')}`;
    }

    if (productsMap[showBundleGroupDialog]?.isHiddenDeal) {
      let productInfo =
        productsMap[optionId] ||
        productsMap[showBundleGroupDialog]?.items?.find((item) => item.id == optionId);
      navigate(productRoute, {
        state: {
          retUrl: window.location.pathname,
        },
      });
      dispatch(
        addProductToCustomize({
          productType: 'bundle',
          updatedOn: new Date().getTime(),
          mainProductId: productsMap[showBundleGroupDialog],
          data: {
            ...productInfo,
            id: showBundleGroupDialog,
            category: productsMap[showBundleGroupDialog]?.categories[0],
            noIncrement: true,
          },
        })
      );
    } else {
      dispatch(
        getProductInfo({
          id: showBundleGroupDialog,
          cluster: clusterId,
          service: address?.addressSubType || 'DELIVERY',
          categoryId: productsMap[showBundleGroupDialog]?.categories[0] || category?.id,
          Language: intl.locale.charAt(0).toUpperCase() + intl.locale.slice(1),
        })
      ).then((resp) => {
        let selectedProductItem = resp.payload?.items?.find((item) => {
          let itemInfo;
          if (!item?.id) {
            itemInfo = productsMap[item];
          } else {
            itemInfo = item;
          }

          return itemInfo['sel1Value'] == optionId;
        });

        if (!selectedProductItem?.id) {
          selectedProductItem = productsMap[selectedProductItem];
        }

        dispatch(
          getProductInfo({
            id: selectedProductItem?.id,
            cluster: clusterId,
            service: address?.addressSubType || 'DELIVERY',
            categoryId: productsMap[selectedProductItem?.id]?.categories[0] || category?.id,
            Language: intl.locale.charAt(0).toUpperCase() + intl.locale.slice(1),
          })
        ).then((resp) => {
          navigate(productRoute, {
            state: {
              retUrl: window.location.pathname,
            },
          });
          let selectedBundle = productsMap[showBundleGroupDialog]?.items?.find((item) => {
            let itemInfo;
            if (item?.id) {
              itemInfo = item;
            } else {
              itemInfo = productsMap[item];
            }

            return itemInfo['sel1Value'] == optionId;
          });

          if (!selectedBundle?.id) {
            selectedBundle = productsMap[selectedBundle];
          }

          if (!selectedBundle?.steps?.[0]?.options) {
            selectedBundle = resp?.payload;
          }

          dispatch(
            addProductToCustomize({
              productType: 'bundle',
              updatedOn: new Date().getTime(),
              mainProductId: productsMap[showBundleGroupDialog],
              data: {
                ...selectedBundle,
                id: showBundleGroupDialog,
                selectedBundleId: selectedBundle?.id,
                category: productsMap[showBundleGroupDialog]?.categories[0],
                noIncrement: true,
              },
            })
          );
        });
      });
    }
  };

  const handleBundleGroup = (productId) => {
    setShowBundleGroupDialog(productId);
  };

  return (
    <div
      className={ClassNames(
        css.root,
        { [css.extraPadding]: productCard },
        { [css.spacingTile]: productTile }
      )}
    >
      {pageLoader && <Loader />}
      {/* MOBILE PRODUCT CARD RENDER */}
      {productCard && !isDesktop
        ? sortedProducts.map((product, i) => (
            <ProductCard
              className={css.productCard}
              product={product}
              productButtonTitle={productButtonTitle}
              key={i}
              imgBaseUrl={productUrl}
              index={i}
            />
          ))
        : ''}
      {/*  PRODUCT CARD LOADING */}
      {/* {productCard && isDesktop && productItems?.length === 0 && (
        <>
          <Box sx={{ padding: '10px' }}>
            <Skeleton count={3} className={css.Skeleton} height={50} />
          </Box>
        </>
      )} */}
      {/* DESKTOP PRODUCT CARD RENDER */}
      {productCard && isDesktop
        ? sortedProducts.map((p, i) => {
            let product = JSON.parse(JSON.stringify(p));
            const category = categoryList.entities[product.action.category_id];
            const inCusto = temp?.customize?.items?.findIndex(
              ({ id }) => id === +product.action.id
            );
            let prdItem = productItems[i];
            const productVal = inCusto !== -1 ? temp.customize.items[inCusto] : prdItem || {};

            if (!product?.['assets'] || !product?.['id']) {
              product['assets'] = [{ src: product['mediaUrl'] }];
              product['price'] = product['originalPrice'];
              product['specialPrice'] = product['originalPrice'];
              product['categories'] = [product.action.category_id];
              product['id'] = product.action.id;
              product['isHomePageItem'] = true;
              product['name'] = product[`name_${intl.locale}`] || product[`name_en`];
            }

            return (
              <ProductTile
                returnURL={`/${intl.locale}/home`}
                key={product[`name_${intl.locale}`] + '-Val-' + product.action.id}
                isCustomized={inCusto}
                category={category}
                onAddCart={addtoCart}
                productObj={
                  productsList.entities[product.action.id]
                    ? { ...productsList.entities[product.action.id], isHomePageItem: true }
                    : product
                }
                position={'MainITEM' + i}
                priceTo={
                  product?.specialPrice ? product?.specialPrice || 0 : product?.originalPrice || 0
                }
                index={i}
                setShowCustomizeProductDialog={setShowCustomizeProductDialog}
                setShowBundleGroupDialog={
                  product?.bundleTypeId == 'bundle_group' || product?.typeId == 'bundle_group'
                    ? setShowBundleGroupDialog
                    : null
                }
              />
            );
          })
        : ''}
      {/* BESTSELLER PRODUCT CARD RENDERING */}
      {productTile
        ? sortedProducts.map((productValue) => {
            const isExist = categoryList.entities[productValue?.action?.category_id];
            const locale = 'en';
            let product = productsList.entities[productValue.action.id]
              ? productsList.entities[productValue.action.id]
              : null;
            const ItemName = productsList.entities[productValue.action.id]
              ? productsList.entities[productValue.action.id].name
              : '';
            let category = {};
            let productRoute = '';

            if (!product?.['assets'] || !product?.['id']) {
              if (!product) {
                const name =
                  productValue[`name_${intl.locale}`] ||
                  productValue[`name`] ||
                  productValue[`title`];
                product = {
                  name: name,
                  title: name,
                  [`name_${intl.locale}`]: name,
                };
              }
              product['assets'] = [{ src: productValue['mediaUrl'] }];
              product['price'] = productValue['originalPrice'];
              product['specialPrice'] = productValue['originalPrice'];
              product['categories'] = [productValue.action.category_id];
              product['id'] = productValue.action.id;
              product['isHomePageItem'] = true;
            }

            if (typeof isExist !== 'undefined') {
              category = categoryList.entities[productValue?.action?.category_id];
              if (typeof category !== 'undefined') {
                productRoute = generateProductRoute({ product, category, locale: intl.locale });
              }
            }
            if (
              (product?.bundleTypeId === 'bundle' || product?.bundleTypeId === 'bundle_group') &&
              product?.typeId != 'simple'
            ) {
              productRoute = `${productRoute}/bundle`;
            }

            return productRoute && product?.bundleTypeId !== 'bundle_group' ? (
              <div
                className={css.productTile}
                onClick={() => {
                  handleBannerClick(product?.id, product?.categories?.[0], productRoute);
                }}
              >
                <img src={`${productValue?.mediaUrl}`} alt />
              </div>
            ) : (
              <a
                href
                key={productValue?.mediaUrl}
                onClick={() => handleBundleGroup(productValue?.action?.id)}
              >
                <div className={css.productTile}>
                  <img src={`${productValue?.mediaUrl}`} alt="check-Bestseller" />
                </div>
              </a>
            );
          })
        : ''}

      {showCustomizeProductDialog > 0 && (
        <ProductCustomizationDialog
          setShowCustomizeProductDialog={setShowCustomizeProductDialog}
          showCustomizeProductDialog={showCustomizeProductDialog}
          setShowBundleGroupDialog={setShowBundleGroupDialog}
          oldLocation={JSON.parse(JSON.stringify(location))}
          returnURL={window.location.pathname}
        />
      )}
      {showBundleGroupDialog > 0 && (
        <BundleGroupDialog
          setShowBundleGroupDialog={setShowBundleGroupDialog}
          showBundleGroupDialog={showBundleGroupDialog}
          handleBundleGroupAction={handleBundleGroupAction}
        />
      )}
    </div>
  );
}
